import { createCachedSelector, prop } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { ClientSymbolFilter } from '@cbridge-packages/symbol-client';
import { selectedSymbolMappingFilterSelector } from '../../_selectors/selectedSymbolMappingFilter.selector';

export const symbolMappingFilterItemPropsSelector = createCachedSelector(
  [
    selectedSymbolMappingFilterSelector,
    prop<{ optionId: ClientSymbolFilter }>().optionId(),
  ],
  (selectedFilter, optionId) => {
    return selectedFilter === optionId;
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: prop<{ optionId: ClientSymbolFilter }>().optionId(),
});
